import React from "react";
import { Col, Container, Row, Tab, Nav, Accordion } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Topfeatures() {
  return (
    <section className="top_health_features tools-automation p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <h2>
              Tools We <span>Specialize</span> in
            </h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="">
            <Tab.Container id="" defaultActiveKey="0">
              <Nav variant="pills" className="flex-column">
                <div className="medical_item">
                  <Nav.Item>
                    <Nav.Link eventKey="0">All</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="1">Cloud Platforms</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="2">DevOps & CI/CD Tools</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="3">
                      Languages & Frameworks / Automation Platforms
                    </Nav.Link>
                  </Nav.Item>
                </div>
              </Nav>
              <Row>
                <Tab.Content>
                  <Tab.Pane eventKey="0">
                    <ul>
                      <li>
                        <StaticImage
                          src="../../images/business-automation/tools/appian.webp"
                          alt="TekRevol"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={180}
                          height={102}
                        />
                      </li>
                      <li>
                        <StaticImage
                          src="../../images/business-automation/tools/auto.webp"
                          alt="TekRevol"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={180}
                          height={102}
                        />
                      </li>
                      <li>
                        <StaticImage
                          src="../../images/business-automation/tools/aws.webp"
                          alt="TekRevol"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={180}
                          height={102}
                        />
                      </li>
                      <li>
                        <StaticImage
                          src="../../images/business-automation/tools/azure.webp"
                          alt="TekRevol"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={180}
                          height={102}
                        />
                      </li>
                      <li>
                        <StaticImage
                          src="../../images/business-automation/tools/azure-devops.webp"
                          alt="TekRevol"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={180}
                          height={102}
                        />
                      </li>
                      <li>
                        <StaticImage
                          src="../../images/business-automation/tools/bm-watson.webp"
                          alt="TekRevol"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={180}
                          height={102}
                        />
                      </li>
                      <li>
                        <StaticImage
                          src="../../images/business-automation/tools/ci-cd-git.webp"
                          alt="TekRevol"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={180}
                          height={102}
                        />
                      </li>
                      <li>
                        <StaticImage
                          src="../../images/business-automation/tools/google-cloud.webp"
                          alt="TekRevol"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={180}
                          height={102}
                        />
                      </li>
                      <li>
                        <StaticImage
                          src="../../images/business-automation/tools/ibm.webp"
                          alt="TekRevol"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={180}
                          height={102}
                        />
                      </li>
                      <li>
                        <StaticImage
                          src="../../images/business-automation/tools/jenkins.webp"
                          alt="TekRevol"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={180}
                          height={102}
                        />
                      </li>
                      <li>
                        <StaticImage
                          src="../../images/business-automation/tools/pega.webp"
                          alt="TekRevol"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={180}
                          height={102}
                        />
                      </li>
                      <li>
                        <StaticImage
                          src="../../images/business-automation/tools/power-auto.webp"
                          alt="TekRevol"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={180}
                          height={102}
                        />
                      </li>
                      <li>
                        <StaticImage
                          src="../../images/business-automation/tools/tensor.webp"
                          alt="TekRevol"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={180}
                          height={102}
                        />
                      </li>
                      <li>
                        <StaticImage
                          src="../../images/business-automation/tools/ui-path.webp"
                          alt="TekRevol"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={180}
                          height={102}
                        />
                      </li>
                    </ul>
                  </Tab.Pane>
                  <Tab.Pane eventKey="1">
                    <ul>
                      <li>
                        <StaticImage
                          src="../../images/business-automation/tools/aws.webp"
                          alt="TekRevol"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={180}
                          height={102}
                        />
                      </li>
                      <li>
                        <StaticImage
                          src="../../images/business-automation/tools/google-cloud.webp"
                          alt="TekRevol"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={180}
                          height={102}
                        />
                      </li>
                      <li>
                        <StaticImage
                          src="../../images/business-automation/tools/azure.webp"
                          alt="TekRevol"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={180}
                          height={102}
                        />
                      </li>
                    </ul>
                  </Tab.Pane>
                  <Tab.Pane eventKey="2">
                    <ul>
                      <li>
                        <StaticImage
                          src="../../images/business-automation/tools/azure-devops.webp"
                          alt="TekRevol"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={180}
                          height={102}
                        />
                      </li>
                      <li>
                        <StaticImage
                          src="../../images/business-automation/tools/jenkins.webp"
                          alt="TekRevol"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={180}
                          height={102}
                        />
                      </li>
                      <li>
                        <StaticImage
                          src="../../images/business-automation/tools/ci-cd-git.webp"
                          alt="TekRevol"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={180}
                          height={102}
                        />
                      </li>
                    </ul>
                  </Tab.Pane>
                  <Tab.Pane eventKey="3">
                    <ul>
                      <li>
                        <StaticImage
                          src="../../images/business-automation/tools/appian.webp"
                          alt="TekRevol"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={180}
                          height={102}
                        />
                      </li>
                      <li>
                        <StaticImage
                          src="../../images/business-automation/tools/auto.webp"
                          alt="TekRevol"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={180}
                          height={102}
                        />
                      </li>
                      <li>
                        <StaticImage
                          src="../../images/business-automation/tools/tensor.webp"
                          alt="TekRevol"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={180}
                          height={102}
                        />
                      </li>
                      <li>
                        <StaticImage
                          src="../../images/business-automation/tools/ui-path.webp"
                          alt="TekRevol"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={180}
                          height={102}
                        />
                      </li>
                      <li>
                        <StaticImage
                          src="../../images/business-automation/tools/pega.webp"
                          alt="TekRevol"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={180}
                          height={102}
                        />
                      </li>
                      <li>
                        <StaticImage
                          src="../../images/business-automation/tools/power-auto.webp"
                          alt="TekRevol"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={180}
                          height={102}
                        />
                      </li>
                      <li>
                        <StaticImage
                          src="../../images/business-automation/tools/ibm.webp"
                          alt="TekRevol"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={180}
                          height={102}
                        />
                      </li>
                      <li>
                        <StaticImage
                          src="../../images/business-automation/tools/bm-watson.webp"
                          alt="TekRevol"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["webp"]}
                          width={180}
                          height={102}
                        />
                      </li>
                    </ul>
                  </Tab.Pane>
                </Tab.Content>
              </Row>
            </Tab.Container>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Topfeatures;
